import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import type { ApproveVoucherRequestDto } from "../../dtos/approve-voucher-request-dto";
import type { ApproveVoucherResponseDto } from "../../dtos/approve-voucher-response-dto";
import { VoucherQueryKeys } from "../../generators/voucher-query-keys";
import { VoucherService } from "../../services/voucher-service";

type UsePostApproveVoucherMutationParams = {
  options?: UseMutationOptions<
    ApproveVoucherResponseDto,
    unknown,
    ApproveVoucherRequestDto
  >;
};

export const usePostApproveVoucherMutation = ({
  options
}: UsePostApproveVoucherMutationParams = {}) => {
  const queryClient = useQueryClient();
  const { q, page, sort } = useSearch({ from: "/vouchers/" });

  return useMutation({
    mutationFn: async (payload) => {
      return await VoucherService.approveVoucher({ payload });
    },
    onSuccess: async (...args) => {
      const currentPageKey = VoucherQueryKeys.getVoucherList({
        limit: 10,
        page,
        q,
        sort
      }).queryKey;

      await queryClient.invalidateQueries({ queryKey: currentPageKey });

      options?.onSuccess?.(...args);
    },
    ...options
  });
};
